<template>
  <div class="py-0" style="right: 0; left: 0;">
    <!-- <b-navbar type="dark" variant="primary" toggleable> -->
    <nav class="navbar navbar-expand-lg navbar-custom py-0">
      <button
        class="navbar-toggler"
        type="button"
        :aria-expanded="isNavOpen ? 'true' : 'false'"
        aria-controls="navbarCustom"
        @click="toggleNavbar"
      >
        <i class="fa fa-bars fa-lg py-1 text-white"></i>
      </button>
      <div class="collapse navbar-collapse" :class="{ show: isNavOpen }" id="navbarCustom">
        <ul class="navbar-nav">
          <li class="nav-item" v-if="RoleID==0">
            <!-- <a class="nav-link" href="/dashboard">HOME</a> -->
            <router-link class="nav-link" to="/dashboard" @click.native="closeNavbar">HOME</router-link>
          </li>
          <li class="nav-item" v-if="RoleID!=0">
            <!-- <a class="nav-link" to="/admindashboard">HOME</a> -->
            <router-link class="nav-link" to="/admindashboard" @click.native="closeNavbar">HOME</router-link>
          </li>

          <div class="dropdown">
            <button class="nav-item dropbtn">
              MY ACCOUNT
              <i class="fa fa-caret-down"></i>
            </button>
            <div class="dropdown-content">
              <!-- <a v-if="RoleID==0" href="/Eprofile" class="dropdown-item">EDIT PROFILE</a>
                  <a v-if="RoleID!=0" href="/applications" class="dropdown-item">Application List</a>
                  <a v-if="RoleID==3"  href="/resetPassword" class="dropdown-item">RESET PASSWORD</a>
              <a href="/changePassword" class="dropdown-item">CHANGE PASSWORD</a>-->

              <!--<router-link v-if="RoleID==0" to="/Eprofile" class="dropdown-item">EDIT PROFILE</router-link>-->

              <router-link
                v-if="RoleID!=0"
                to="/applications"
                class="dropdown-item"
                @click.native="closeNavbar"
              >Application List</router-link>
              <router-link v-if="RoleID==3" to="/resetPassword" class="dropdown-item" @click.native="closeNavbar">RESET PASSWORD</router-link>
              <router-link v-if="RoleID==3" to="/changeboard" class="dropdown-item" @click.native="closeNavbar">CHANGE DISTRICT</router-link>
              <router-link to="/changePassword" class="dropdown-item" @click.native="closeNavbar">CHANGE PASSWORD</router-link>
            </div>
          </div>

          <div v-if="RoleID==0 && isLOI" class="dropdown">
            <button class="nav-item dropbtn">
              LOAN DETAILS
              <i class="fa fa-caret-down"></i>
            </button>
            <div class="dropdown-content">
              <!-- <a href="/sanctionletter" class="dropdown-item">Sanction Letter</a>
                  <a href="/disbursal" class="dropdown-item">Disbursal Details</a>
                  <a href="/claimupload" class="dropdown-item">Claim Upload</a>
              <a href="/claims" class="dropdown-item">Claim List</a>-->
              <router-link to="/sanctionletter" class="dropdown-item" @click.native="closeNavbar">Sanction Letter</router-link>
              <router-link to="/disbursal" class="dropdown-item" @click.native="closeNavbar">Disbursal Details</router-link>
              <router-link to="/claimupload" class="dropdown-item" @click.native="closeNavbar">Claim Upload</router-link>
              <router-link to="/claims" class="dropdown-item" @click.native="closeNavbar">Claim List</router-link>
            </div>
          </div>
          <div v-if="RoleID!=0 " class="dropdown">
            <button class="nav-item dropbtn">
              LOANS
              <i class="fa fa-caret-down"></i>
            </button>
            <div class="dropdown-content">
              <!-- <a href="/sanctionletters" class="dropdown-item">Sanction Letters</a>
                  <a href="/disbursals" class="dropdown-item">Disbursals</a>
              <a href="/approveclaims" class="dropdown-item">Claims</a>-->
              <router-link to="/sanctionletters" class="dropdown-item" @click.native="closeNavbar">Sanction Letters</router-link>
              <router-link to="/disbursals" class="dropdown-item" @click.native="closeNavbar">Disbursals</router-link>
              <router-link v-if="RoleID!=2" to="/approveclaims" class="dropdown-item" @click.native="closeNavbar">Claims</router-link>
            </div>
          </div>
          <!-- <b-nav-item-dropdown class="nav-item dropdown" style="color:white;font-weight: 500;
                  font-stretch: normal;font-size: 14px;" text="MY ACCOUNT" left>
                  <b-dropdown-item v-if="RoleID==0" class="dropdown-item" href="/Eprofile"><i class="fa fa-pencil-alt"></i> <span>Edit Profile</span></b-dropdown-item>
                  <b-dropdown-item v-if="RoleID!=0" class="dropdown-item" href="/applications"><i class="fa fa-pencil-alt"></i> <span>Application List</span></b-dropdown-item>
                  <b-dropdown-item v-if="RoleID==3" class="dropdown-item" href="/resetPassword"><i class="fa fa-pencil-alt"></i> <span>Reset Password</span></b-dropdown-item>
                  <b-dropdown-item class="dropdown-item" href="/changePassword"><i class="fa fa-pencil-alt"></i> <span>Change Password</span></b-dropdown-item>
          </b-nav-item-dropdown>-->
          <li class="nav-item" v-if="RoleID!=0">
            <!-- <a class="nav-link" href="/reports">REPORTS</a> -->
            <router-link class="nav-link" to="/reports" @click.native="closeNavbar">MIS</router-link>
          </li>
          <li class="nav-item" v-if="RoleID!=0 || RoleID!=2">
            <router-link class="nav-link" to="/adminreports" @click.native="closeNavbar">REPORTS</router-link>
          </li>
          <li class="nav-item" v-if="RoleID!=0">
            <router-link class="nav-link" to="/subcompanyreport" @click.native="closeNavbar">SUB COMPANY</router-link>
          </li>
        </ul>

        <span class="ml-auto mr-5">
          <ul class="navbar-nav">
            <li class="nav-brand">
              <a class="nav-link" href="#">WELCOME {{username}}</a>
            </li>
            <!-- <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Language
                  </a>
                  <div class="dropdown-menu dropdown-menu-left" aria-labelledby="navbarDropdown">
                      <a class="dropdown-item" href="#" @click="setLang('en', 'English')">English</a>
                      <a class="dropdown-item" href="#" @click="setLang('mr','मराठी')">मराठी</a>
                  </div>
            </li>-->
            <li class="nav-item dropdown" style="border-left: 1px solid #fff;">
              <a class="nav-link" href="#" @click="logout">LOGOUT</a>
            </li>
          </ul>
        </span>
      </div>
    </nav>
    <!-- </b-navbar> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      isNavOpen: false
    };
  },
  methods: {
    toggleNavbar() {
      this.isNavOpen = !this.isNavOpen;
    },
    closeNavbar() {
      this.isNavOpen = false;
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.replace("/");
    },
    login() {
      this.$router.replace("/");
    },
    setLanguage() {
      var temp_lang = document.getElementsByClassName("goog-te-combo")[0].value;
      var flang =
        temp_lang == "hi" ? "हिन्दी" : temp_lang == "mr" ? "मराठी" : "English";

      document.querySelector(".lang-bar a.dropdown-toggle").innerHTML = flang;
    }
  },
  computed: {
    username() {
      var nme = this.$store.getters.loggedUser;
      return nme.UserName;
    },
    RoleID() {
      var nme = this.$store.getters.loggedUser;
      return nme.RoleID;
      //alert(nme.RegistrationType);
    },
    LockProfile() {
      var lck = this.$store.getters.lockProfile;
      return lck;
    },
    isLOI() {
      var LOIStatus = this.$store.getters.getAppStatus;
      console.log(this.$store.getters);
      if (
        LOIStatus == 6 ||
        LOIStatus == 8 ||
        LOIStatus == 9 ||
        LOIStatus == 21 ||
        LOIStatus == 22 ||
        LOIStatus ==16 ||
        LOIStatus==27
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.navbar-custom {
  background-color: #2e4b90 !important;
  min-height: 70px;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;
  line-height: 54px;
  font-family: "Open sans", sans-serif;
  text-transform: uppercase;
}
/* change the brand and text color */
.navbar-custom .navbar-brand,
.navbar-custom .navbar-text {
  color: white;
}
/* change the link color */
.navbar-custom .navbar-nav .nav-link {
  color: white;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;
  font-family: "Open sans", sans-serif;
  padding-left: 30px;
  text-transform: uppercase;
}

/* change the color of active or hovered links */
.navbar-custom .nav-item.active .nav-link,
.navbar-custom .nav-item:hover .nav-link {
  color: #f4ff60;
  padding-left: 30px;
}

.navbar-custom .dropdown-menu {
  background-color: #2e4b90 !important;
  margin-left: -50px;
}
.navbar-custom .dropdown-menu-left {
  background-color: #2e4b90 !important;
  margin-left: 10px !important;
}
.navbar-custom .dropdown-item {
  color: #ffffff;
  height: 40px !important;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;
  font-family: "Open sans", sans-serif;
  line-height: 34px;
  padding-left: 30px;
  text-transform: uppercase;
}

.dropdown-item a {
  color: #ffffff;
  height: 40px !important;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;
  font-family: "Open sans", sans-serif;
  line-height: 34px;
  padding-left: 30px;
  text-transform: uppercase;
}
.navbar-custom .dropdown-item:hover,
.navbar-custom .dropdown-item:focus {
  /* color: #333333;
  background-color: rgba(255, 255, 255, 0.5); */
  color: black;
  background-color: white;
  display: block;
}

/* Dropdown Button */
.navbar-custom .dropbtn {
  height: 70px;
  background-color: #2e4b90 !important;
  color: white;
  font-style: normal;
  font-variant-ligatures: normal;
  font-variant-caps: normal;
  font-variant-numeric: normal;
  font-variant-east-asian: normal;
  font-weight: 500;
  font-stretch: normal;
  font-size: 14px;

  font-family: "Open sans", sans-serif;
  border: none;
  padding-left: 30px;
  text-transform: uppercase;
}

/* The container <div> - needed to position the dropdown content */
.navbar-custom .dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #2e4b90;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1000;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: white;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {
  background-color: #ddd;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn:hover {
  background-color: #f4ff60;
}

.header_aera .navbar-collapse .navbar-nav.navbar-right li a {
  margin-top: -15px;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationNavbar.vue